<template>
  <div>
   <CheckReconcilation/>
  </div>
</template>

<script>
import CheckReconcilation from '../../../../components/tax/payments/utils/checkReconcilation/CheckReconcilation.vue';

export default {
  name: 'checkreconciliation',
  components: {
    CheckReconcilation,
  },
};
</script>
